import React from "react";
import { Card } from "antd";
import { Redirect, useParams } from "react-router-dom";
import navigationConfig from "configs/NavigationConfig";

// Body of a module page whose first-level tabs live in the page header
// (ModuleHeader renders them from the module's NavigationConfig submenu).
// The route's :tab segment picks the screen; the bare module path, or an
// unknown tab, lands on the first tab. Screens built from their own cards
// render as-is; `framed` wraps screens that have none in a page card.
const ModuleTabContent = ({ navKey, screens, framed = false }) => {
  const { tab } = useParams();
  const tabs = navigationConfig.find((menu) => menu.key === navKey).submenu;
  const current = tabs.find((sub) => sub.tabKey === tab);

  if (!current || !screens[current.tabKey]) {
    return <Redirect to={tabs[0].path} />;
  }

  const screen = screens[current.tabKey];
  return framed ? (
    <Card key={current.tabKey} bodyStyle={{ padding: "24px 28px" }}>
      {screen}
    </Card>
  ) : (
    <React.Fragment key={current.tabKey}>{screen}</React.Fragment>
  );
};

export default ModuleTabContent;
